// 物资相关的所有接口
import { omit } from "lodash";

import request from "@/utils/request";


// 管理重置密码 /user/admin/resetPwd
export function adminChangePassWord(data) {
  return request({
    url: "/user/admin/resetPwd",
    method: "post",
    data,
  });
}

// 新增教师
export function teacherAddOrEdit(data) {
  return request({
    url: "/user/addOrEdit",
    method: "post",
    data,
  });
}

// 教师删除 
export function userDelete(data) {
  return request({
    url: "/user/delete",
    method: "post",
    params: { ...data },
  });
}


// 教师导入 
export function userImport(data) {
  return request({
    url: "/user/import",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 教师管理的分页
export function teacherPage(data) {
  return request({
    url: "/user/page",
    method: "post",
    data,
  });
}

// 教师的模版下载  /user/downloadTemplate
export function teacherDownloadTemplate() {
  return request({
    url: "/user/downloadTemplate",
    method: "post",
    responseType: "blob",
  });
}


// 物资日志 - 日常消耗物资 - 入库记录  /dailyAssets/stock/page
export function dailyAssetsStockPage(data) {
  return request({
    url: "/dailyAssets/stock/page",
    method: "post",
    data,
  });
}

// 物资日志 - 日常消耗物资 - 入库记录 - 导出 /dailyAssets/stock/export
export function dailyAssetsStockExport(data) {
  return request({
    url: "/dailyAssets/stock/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 物资管理 - 日常消耗物资 - 报废记录 /dailyAssetsScrapApplication/admin/page
export function dailyAssetsScrapApplicationPage(data) {
  return request({
    url: "/dailyAssetsScrapApplication/admin/page",
    method: "post",
    data,
  });
}

// 物资管理 - 物资报废 - 日常消耗物资
export function dailyAssetsScrap(data) {
  return request({
    url: "/dailyAssetsScrapApplication/admin/page",
    method: "post",
    data: data,
  });
}

// 物资管理 - 物资报废 - 导出
export function dailyAssetsScrapExport(data) {
  return request({
    url: "/dailyAssetsScrapApplication/admin/export",
    method: "post",
    data: data,
    responseType: "blob",
  });
}

// 食材物资 - 出入库记录
export function foodRecordStockInOutPage(data) {
  return request({
    url: "/foodMaterialAssetsStockRecord/stockInOutPage",
    method: "post",
    data,
  });
}

// 食材物资 - 出入库详情
export function foodRecordStockInOutPageDetail(data) {
  return request({
    url: "/foodMaterialAssetsStockRecord/stockInOutPageDetail",
    method: "post",
    data,
  });
}

// 结余记录 /foodMaterialAssetsStockRecord/stockInCategoryDetail
export function foodRecordDetail(data) {
  return request({
    url: "/foodMaterialAssetsStockRecord/stockInCategoryDetail",
    method: "post",
    data,
  });
}

// 物资管理 - 低值易耗物资 - 低值易耗物资列表
export function consumableAssetsList(data) {
  return request({
    url: "/consumableAssetsInfo/backend/getConsumableAssetsList",
    method: "get",
    params: { ...data },
  });
}

// 物资管理 - 低值易耗物资 - 新增低值易耗物资 consumableAssetsInfo/backend/addConsumableAssets
export function addConsumableAssets(data) {
  return request({
    url: "/consumableAssetsInfo/backend/addConsumableAssets",
    method: "post",
    data,
  });
}

// 物资管理 - 低值易耗物资 - 报废出库
export function submitScrapAssets(data) {
  return request({
    url: "/consumableAssetsInfo/all/submitScrapAssets",
    method: "post",
    data,
  });
}


// 物资管理 - 日志 - 低值易耗物资入库
export function getInstoredConsumableLog(data) {
  return request({
    url: "/consumableAssetsInfo/backend/getInstoredConsumableLog",
    method: "get",
    params: { ...data },
  });
}

// 物资管理 - 日志 - 低值易耗物资导出
export function getExcelInstoredConsumableLog(data) {
  return request({
    url: "/consumableAssetsInfo/backend/getExcelInstoredConsumableLog",
    method: "post",
    params: { ...data },
    responseType: "blob",
  });
}

// 物资管理 - 报废记录 - 低值易耗物资
export function getConsumableScrapDataList(data) {
  return request({
    url: "/consumableAssetsInfo/backend/getConsumableAssetsScrapDataList",
    method: "get",
    params: { ...data },
  });
}

// 物资管理 - 报废记录 - 低值易耗物资 - 导出
export function getExcelDataList(data) {
  return request({
    url: "/consumableAssetsInfo/backend/getExcelConsumableAssetsScrapDataList",
    method: "post",
    params: { ...data },
    responseType: "blob",
  });
}

// 食材物资- 出入库 - 导出 /foodMaterialAssetsStockRecord/stockInOutPage/export
export function getfoodExcelDataList(data) {
  return request({
    url: "/foodMaterialAssetsStockRecord/stockInOutPage/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 物资管理 - 结余记录 - 导出 /foodMaterialAssetsStockRecord/stockInCategoryDetail/export
export function balanceExcelDataList(data) {
  return request({
    url: "/foodMaterialAssetsStockRecord/stockInCategoryDetail/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 物资管理 - 低值易耗物资 - 出库记录 /consumableAssetsInfo/backend/getOutStockConsumableAssetsList
export function outStockConsumableAssetsList(data) {
  return request({
    url: "/consumableAssetsInfo/backend/getOutStockConsumableAssetsList",
    method: "get",
    params: { ...data },
  });
}

// 物资日志 - 低值易耗物资 - 出库记录导出
export function getExcelConsumableAssetsList(data) {
  return request({
    url: "/consumableAssetsInfo/backend/getExcelOutStockConsumableAssetsList",
    method: "post",
    params: { ...data },
    responseType: "blob",
  });
}

// 物资日志 - 低值易耗物资 - 预警记录
export function getConsumableAssetsAlarmList(data) {
  return request({
    url: "/consumableAssetsInfo/backend/getConsumableAssetsAlarmList",
    method: "get",
    params: { ...data },
  });
}

// 物资日志 - 低值易耗物资 - 预警记录导出
export function getExcelConsumableAssetsAlarmList(data) {
  return request({
    url: "/consumableAssetsInfo/backend/getExcelConsumableAssetsAlarmList",
    method: "post",
    params: { ...data },
    responseType: "blob",
  });
}

// 物资日志 唤起打印
export function print(data) {
  return request({
    url: "/foodMaterialAssetsStockRecord/stockInOutDetail/print",
    method: "post",
    params: { ...data },
    responseType: "blob",
  });
}

// 固定物资 - 查询列表
export function getFixedAssetsInfoList(data) {
  return request({
    url: "/fixedAssetsInfo/backend/getDataList",
    method: "get",
    params: { ...data },
  });
}

// 固定物资 - 新增
export function addNewFixedAssets(data) {
  return request({
    url: "/fixedAssetsInfo/addNewFixedAssets",
    method: "post",
    data,
  });
}

// 固定物资 - 报废出库的处理
export function scrapOutStock(data) {
  return request({
    url: "/fixedAssetsInfo/backend/scrapOutStock",
    method: "post",
    data,
  });
}

// 固定物资 - 报废列表
export function getScrapOutStockLog(data) {
  return request({
    url: "/fixedAssetsInfo/backend/getScrapOutStockLog",
    method: "get",
    params: { ...data },
  });
}

// 固定物资 - 报废列表 - 导出
export function getScrapOutStockLogExport(data) {
  return request({
    url: "/fixedAssetsInfo/backend/getExcelScrapOutStockLog",
    method: "post",
    params: { ...data },
    responseType: "blob",
  });
}

// 固定物资 - 入库记录 -
export function getInstoreLogList(data) {
  return request({
    url: "/fixedAssetsInfo/backend/getInstoreLogList",
    method: "get",
    params: { ...data },
  });
}

// 固定物资 - 入库记录 - 导出
export function getExcelInstoreLogList(data) {
  return request({
    url: "/fixedAssetsInfo/backend/getExcelInstoreLogList",
    method: "post",
    params: { ...data },
    responseType: "blob",
  });
}

// 食材物资 - 入库详情
export function getStockInStatistic(data) {
  return request({
    url: "/foodMaterialAssetsStockRecord/stockInStatistic",
    method: "post",
    data,
  });
}

// 食材物资 - 入库详情导出
export function getStockInStatisticExport(data) {
  return request({
    url: "/foodMaterialAssetsStockRecord/stockInStatistic/export",
    method: "post",
    data,
    responseType: "blob",
  });
}
